import { lazy } from "react";
import type { RouteObject } from "react-router";

const FleetIndex = lazy(() => import("./pages/page"));
const Dashboard = lazy(() => import("./pages/dashboard/page"));

// Vehicles
const Vehicles = lazy(() => import("./pages/vehicles/page"));
const VehicleNew = lazy(() => import("./pages/vehicles/new/page"));
const VehicleDetail = lazy(() => import("./pages/vehicles/[id]/page"));
const VehicleEdit = lazy(() => import("./pages/vehicles/[id]/edit/page"));

// Maintenance
const Maintenance = lazy(() => import("./pages/maintenance/page"));
const MaintenanceNew = lazy(() => import("./pages/maintenance/new/page"));
const MaintenanceDetail = lazy(() => import("./pages/maintenance/[id]/page"));
const MaintenanceEdit = lazy(() => import("./pages/maintenance/[id]/edit/page"));
const MaintenanceSchedule = lazy(() => import("./pages/maintenance/schedule/page"));

// Vehicle Transfers
const VehicleTransfers = lazy(() => import("./pages/vehicle-transfers/page"));
const VehicleTransferDetail = lazy(() => import("./pages/vehicle-transfers/[id]/page"));

// Vehicle Yards
const VehicleYards = lazy(() => import("./pages/vehicle-yards/page"));
const VehicleYardDetail = lazy(() => import("./pages/vehicle-yards/[id]/page"));

// Standalone
const Brands = lazy(() => import("./pages/brands/page"));
const Settings = lazy(() => import("./pages/settings/page"));

// Tax — full-page forms (#399)
const Tax = lazy(() => import("./pages/tax/page"));
const TaxNew = lazy(() => import("./pages/tax/new/page"));
const TaxDetail = lazy(() => import("./pages/tax/[id]/page"));
const TaxEdit = lazy(() => import("./pages/tax/[id]/edit/page"));

// Insurance — full-page forms (#399)
const Insurance = lazy(() => import("./pages/insurance/page"));
const InsuranceNew = lazy(() => import("./pages/insurance/new/page"));
const InsuranceDetail = lazy(() => import("./pages/insurance/[id]/page"));
const InsuranceEdit = lazy(() => import("./pages/insurance/[id]/edit/page"));

// Registrations — full-page forms (#399)
const Registrations = lazy(() => import("./pages/registrations/page"));
const RegistrationNew = lazy(() => import("./pages/registrations/new/page"));
const RegistrationDetail = lazy(() => import("./pages/registrations/[id]/page"));
const RegistrationEdit = lazy(() => import("./pages/registrations/[id]/edit/page"));

// Legacy redirect component `pages/new-record-redirect.tsx` from #404 is kept
// as a harmless fallback file in case any other modal-based doctype needs it
// in the future. #399 promoted tax / insurance / registrations to real
// `/new` pages, so the redirect is no longer routed anywhere here.

// Reports
const Reports = lazy(() => import("./pages/reports/page"));
const MaintenanceCosts = lazy(() => import("./pages/reports/maintenance-costs/page"));
const Lifecycle = lazy(() => import("./pages/reports/lifecycle/page"));
const Utilization = lazy(() => import("./pages/reports/utilization/page"));
const VehicleLifecycle = lazy(() => import("./pages/reports/vehicle-lifecycle/page"));
const Upcoming = lazy(() => import("./pages/reports/upcoming/page"));

export const fleetRoutes: RouteObject[] = [
  { index: true, Component: FleetIndex },
  { path: "dashboard", Component: Dashboard },

  // Vehicles
  { path: "vehicles", Component: Vehicles },
  { path: "vehicles/new", Component: VehicleNew },
  { path: "vehicles/:id", Component: VehicleDetail },
  { path: "vehicles/:id/edit", Component: VehicleEdit },

  // Maintenance
  { path: "maintenance", Component: Maintenance },
  { path: "maintenance/new", Component: MaintenanceNew },
  { path: "maintenance/schedule", Component: MaintenanceSchedule },
  { path: "maintenance/:id", Component: MaintenanceDetail },
  { path: "maintenance/:id/edit", Component: MaintenanceEdit },

  // Vehicle Transfers
  { path: "vehicle-transfers", Component: VehicleTransfers },
  { path: "vehicle-transfers/:id", Component: VehicleTransferDetail },

  // Vehicle Yards
  { path: "vehicle-yards", Component: VehicleYards },
  { path: "vehicle-yards/:id", Component: VehicleYardDetail },

  // Standalone
  { path: "brands", Component: Brands },

  // Tax — full-page CRUD (#399)
  { path: "tax", Component: Tax },
  { path: "tax/new", Component: TaxNew },
  { path: "tax/:id", Component: TaxDetail },
  { path: "tax/:id/edit", Component: TaxEdit },

  // Insurance — full-page CRUD (#399)
  { path: "insurance", Component: Insurance },
  { path: "insurance/new", Component: InsuranceNew },
  { path: "insurance/:id", Component: InsuranceDetail },
  { path: "insurance/:id/edit", Component: InsuranceEdit },

  // Registrations — full-page CRUD (#399)
  { path: "registrations", Component: Registrations },
  { path: "registrations/new", Component: RegistrationNew },
  { path: "registrations/:id", Component: RegistrationDetail },
  { path: "registrations/:id/edit", Component: RegistrationEdit },

  { path: "settings", Component: Settings },

  // Reports
  { path: "reports", Component: Reports },
  { path: "reports/maintenance-costs", Component: MaintenanceCosts },
  { path: "reports/lifecycle", Component: Lifecycle },
  { path: "reports/utilization", Component: Utilization },
  { path: "reports/vehicle-lifecycle", Component: VehicleLifecycle },
  { path: "reports/upcoming", Component: Upcoming },
];
